import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    Modal, Table, Button, Formatter,
} from 'framework-ui-components';

import { storico } from 'apis/sharedApi';

class ModaleStorico extends Component {
    state = {
        storico: [],
    }

    componentWillMount() {
        this.caricaStorico(this.props.idDichiarazione);
    }

    caricaStorico(idDichiarazione) {
        storico(idDichiarazione)
            .then(x => this.setState({ storico: x }));
    }

    disegnaDatiAggiuntivi(dati) {
        const parsed = JSON.parse(dati);

        return Object.keys(parsed).map((x, i) => {
            if (Array.isArray(parsed[x])) {
                return <ul key={i} className="modaleStorico__list">{parsed[x].map((z, j) => <li key={j}>{z}</li>)}</ul>;
            }
            return <span key={i}>{x}:{parsed[x]}</span>;
        });
    }

    render() {
        const {
            denominazione,
            onClose,
        } = this.props;
        const {
            storico,
        } = this.state;

        return (
            <Modal show onClose={onClose}>
                <Modal.Header>Storico dichiarazione {denominazione}</Modal.Header>
                <Modal.Body>
                    <div className="modaleStorico__body">
                        <Table>
                            <Table.Head>
                                <tr>
                                    <th>Azione</th>
                                    <th>Data modifica</th>
                                </tr>
                            </Table.Head>
                            <Table.Body>
                                {storico.map((x, i) => (
                                    <tr key={i}>
                                        <td>{x.Descrizione}
                                            {x.DatiAddizionali && this.disegnaDatiAggiuntivi(x.DatiAddizionali)}
                                        </td>
                                        <td><Formatter valore={x.Data} tipo="date" /> - <Formatter valore={x.Data} tipo="hour" /></td>
                                    </tr>
                                ))}
                            </Table.Body>
                        </Table>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button flat onClick={onClose}>Chiudi</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

ModaleStorico.propTypes = {
    denominazione: PropTypes.string,
    idDichiarazione: PropTypes.string,
    onClose: PropTypes.func,
};

export default ModaleStorico;
